<template>
  <scroll-center-dialog v-model="opened" @close="close" @apply="save" :title="form_title" :scrolled="false">

  </scroll-center-dialog>

</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";

export default {
  name: "FieldsEditDialog",
  props: {
    opened: Boolean,
    edit: Boolean,
    fieldData: Object
  },
  mixins:[FormErrorsMixin],
  components: {
    ScrollCenterDialog
  },
  data() {
    return {
      field_default: {
        order_type: null,
        field_type: null,
        name: "",
        help: "",
        is_required: false,
        settings: {
          set1: "",
          set2: "",
          set3: ""
        }
      },
      field: undefined
    }
  },
  computed: {
    form_title () {
      return this.edit === false ? "Добавить поле сведений" : "Редактировать поле сведений"
    }
  },
  methods: {
    ...mapActions({
      createFields: "admin/createFields",
      changeFields: "admin/changeFields"
    }),
    loadFieldData(){
      if(this.fieldData === undefined){
        this.field = this.field_default
      }
      else{
        this.field = JSON.parse(JSON.stringify(this.fieldData))
      }
    },
    close(){
      this.$emit("close", false)
    },
    save(){
      if (this.edit) {
        this.changeFields({
          data: this.field,
          finalizer: (val) => {
            this.$emit("close", this.field)
          },
          catcher:(val) => {
            this.mapErrors(val)
          }
        })
      }else {
        this.createFields({
          data: this.field,
          finalizer: (val) => {
            this.$emit("close", this.field)
          },
          catcher:(val) => {
            this.mapErrors(val)
          }
        })
      }
    }
  },
  created() {
    this.loadFieldData()
  }
}
</script>

<style scoped>

</style>